import { Button, Flex, Text } from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import React from "react";

import { FieldLabel } from "../../fields";
import { PollyIcon } from "../../PollyIcon";

type Props = {
  field: FieldDescriptor<number>;
  max?: number;
  minAllowed?: number;
  disabled?: boolean;
  onUpdate?: () => void;
};

export const UserLicensesSelectionField: React.FC<Props> = ({
  field,
  max,
  minAllowed,
  disabled,
  onUpdate,
}) => {
  return (
    <Flex column gap="gap.small" hAlign="center">
      <FieldLabel
        label="User Authoring Licenses"
        size="medium"
        tooltip="Number of assignable licenses for this subscription.  Each license will have its own allotment of monthly responses."
      />
      <Flex gap="gap.medium" vAlign="center">
        <div>
          <Button
            iconOnly
            circular
            icon={<PollyIcon icon="minus-icon" inheritColor />}
            disabled={disabled || field.value <= (minAllowed || 1)}
            onClick={() => {
              field.onChange(field.value - 1);
              onUpdate && onUpdate();
            }}
          />
        </div>
        <Text content={field.value} weight="bold" size="large" />
        <div>
          <Button
            iconOnly
            circular
            icon={<PollyIcon icon="plus-icon" inheritColor />}
            disabled={disabled || field.value >= (max || 50)}
            onClick={() => {
              field.onChange(field.value + 1);
              onUpdate && onUpdate();
            }}
          />
        </div>
      </Flex>
    </Flex>
  );
};
